/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { EnumFieldItemEdit } from "./edit-item";

const EnumFieldEdit = () => {
    return (
        <FieldListEditWrapper>
            <EnumFieldItemEdit />
        </FieldListEditWrapper>
    );
};
EnumFieldEdit.displayName = "EnumFieldEdit";
export { EnumFieldEdit };
